export const FORMS_PATHS = {
  FORMS: '/internal/Forms',
  FORM_EDITOR: '/internal/FormEditor',
  PREVIEW_FORM: '/preview-form',
  OPPORTUNITY_FORM_VIEW: '/opportunityFormView'
} as const
